import { render, staticRenderFns } from "./AdminDestinations.vue?vue&type=template&id=c474e690"
import script from "./AdminDestinations.vue?vue&type=script&lang=js"
export * from "./AdminDestinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports